module.exports = __webpack_public_path__ + "img/avatar-4.5710bce1.png";